import { render, staticRenderFns } from "./out-of-credits-promotion.vue?vue&type=template&id=41191e1a&"
import script from "./out-of-credits-promotion.ts?vue&type=script&lang=ts&"
export * from "./out-of-credits-promotion.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports